import api from '@/services/Api';

class CollaboratorsService {
  async getPaginatedAccountCollaboratorsList(search, sort, order, page, limit, accountId = null) {
    let url = ''
    if (accountId) {
      url = '/distributor/account/' + accountId + '/collaborators/list?search=' + encodeURIComponent(search) + '&sort=' + sort + '&order=' + order + '&page=' + page + '&limit=' + limit;
    } else {
      url = '/account/collaborators/list?search=' + encodeURIComponent(search) + '&sort=' + sort + '&order=' + order + '&page=' + page + '&limit=' + limit;
    }
    const response = await api.get(url)
    return response.data
  }

  async getCollaboratorFromNetwork(collaboratorId) {
    const response = await api.get('/distributor/collaborator-by-network/' + collaboratorId)
    return response.data
  }

  async createNetworkCollaborator(data, accountId) {
    const response = await api.post('/distributor/collaborator-by-account-id/' + accountId, data)
    return response.data
  }

  async updateNetworkCollaborator(data, accountId) {
    const response = await api.put('/distributor/collaborator-by-account-id/' + accountId, data)
    return response.data
  }

  async getCollaborator(collaboratorId) {
    const response = await api.get('/account/collaborator/' + collaboratorId)
    return response.data
  }

  async createCollaborator(data) {
    const response = await api.post('/distributor/collaborator', data)
    return response.data
  }

  async updateCollaborator(data) {
    const response = await api.put('/distributor/collaborator', data)
    return response.data
  }

}

export default new CollaboratorsService()
